import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/infrastructures/new/loading';

export const Route = createFileRoute('/_private/settings/infrastructures/new')({
  component: Loading,
});
